import { put } from 'redux-saga/effects';
import { setResetFilters } from '../actions';

export function* resetFilters() {
    yield put( setResetFilters() );
}